<template>
    <div class="graph-button">
        <a
            v-b-modal="`modal${graphId}`"
            class="uk-icon-image uk-svg uk-border-circle graph-icon uk-align-center uk-text-middle"
        >
            <img :src="require('@/assets/images/icons/icon-help.svg')" alt="modal" />
        </a>
    </div>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "GraphHelp",
    props: {
        graphId: {
            required: true,
            type: Number,
        },
    },
});
</script>
